var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParksMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BA0229"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.5C26 15.7624 25.9832 16.0209 25.9505 16.2744C27.7712 17.3046 29 19.2588 29 21.5C29 24.8137 26.3137 27.5 23 27.5C22.2987 27.5 21.6256 27.3797 21 27.1586V30.5H19V26.9003C18.2499 27.2837 17.4002 27.5 16.5 27.5C13.4624 27.5 11 25.0376 11 22C11 20.5474 11.5631 19.2263 12.483 18.2432C12.8773 19.3232 13.4974 20.2944 14.2858 21.0989L15.7142 19.6991C14.9907 18.9607 14.457 18.0377 14.1906 17.0069C14.0661 16.5254 14 16.0204 14 15.5C14 12.1863 16.6863 9.5 20 9.5C23.3137 9.5 26 12.1863 26 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParksMapIcon);
export default __webpack_public_path__ + "static/media/parks-map-icon.aa4f5d18f7a66b42f7b8a8ba4867e29a.svg";
export { ForwardRef as ReactComponent };